import { formatDistanceToNowStrict } from "date-fns";

export function mapUserChat(chat, userId, type) {
  const currentMember = chat.members.find(m => m.userId === userId);

  let otherMember = null;
  if (type.toLowerCase() === "direct") {
    otherMember = chat.members.find(m => m.userId !== userId);
  }

  return {
    id: chat.id,
    type,
    otherUserId: otherMember?.userId,
    name: chat.chatName || (type.toLowerCase() === "direct" ? "Unknown" : "Unnamed Group"),
    chatImageUrl: chat.chatImageUrl || (type.toLowerCase() === "group" ? "/default-group.png" : null),
    lastMessage: chat.lastMessage?.content || "",
    lastMessageSentBy: chat.lastMessage?.senderId || "",
    lastMessageSentAt: chat.lastMessage?.timestamp || "",
    timestamp: chat.lastMessage?.timestamp
      ? formatTimestamp(chat.lastMessage.timestamp)
      : "",
    currentUserLastReadAt: currentMember?.lastReadAt,
  };
}

function formatTimestamp(timestamp) {
  return formatDistanceToNowStrict(new Date(timestamp), { addSuffix: false })
    .replace(" minutes", "m")
    .replace(" minute", "m")
    .replace(" hours", "h")
    .replace(" hour", "h")
    .replace(" days", "d")
    .replace(" day", "d")
    .replace(" seconds", "s")
    .replace(" second", "s")
    .replace(" months", "mo")
    .replace(" month", "mo")  
    .replace(" years", "y")    
    .replace(" year", "y");
}